// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-closed';

export const Component = () => (
  <path d='M23.563 4.921H10.776l-.767-2.25C9.913 2.238 9.627 2 9.1 2H.958a.946.946 0 0 0-.67.288.946.946 0 0 0-.288.67v18.678c0 .239.096.479.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V5.927c0-.239-.096-.479-.287-.718a.946.946 0 0 0-.67-.288Zm0 4.933v11.781H.958V9.854h22.605Zm0-3.927v2.92H.958v-5.89h8.141l.767 2.3c.143.43.479.67.91.67h12.787Z' />
);

export const viewBox = '0 0 25 25';
